import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  EnvironmentConfiguration, Environments,
  environments
} from './services/environment.configuration';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
  ],
  exports: [

  ],
  providers: [
    {
      provide: Environments,
      useValue: environments,
    },
    EnvironmentConfiguration
  ]
})
export class EnvironmentModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/environment/environment.module.ts